import {lazy} from 'react';

export const SpecialistSettingsAsync = lazy(() =>
    import('./SpecialistSettings')
);
